import * as Types from 'src/actions/project/interested/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { RootState } from 'src/reducers/RootReducer';
import Person from 'src/entities/Person';

export interface CreateProjectInterestedAttempt extends Action {
  type: Types.CREATE_PROJECT_INTERESTED_ATTEMPT;
}

export interface CreateProjectInterestedSuccess extends Action {
  type: Types.CREATE_PROJECT_INTERESTED_SUCCESS;
}

export interface CreateProjectInterestedFailure extends Action {
  type: Types.CREATE_PROJECT_INTERESTED_FAILURE;
}

export type CreateProjectInterestedAction =
  CreateProjectInterestedAttempt
  | CreateProjectInterestedSuccess
  | CreateProjectInterestedFailure;

export interface CreateProjectInterestedThunk extends 
  ThunkAction<Promise<CreateProjectInterestedAction>, RootState, string> {
}

export const createProjectInterestedAttempt: ActionCreator<CreateProjectInterestedAttempt> = () => (
  {
    type: Types.CREATE_PROJECT_INTERESTED_ATTEMPT
  }
);

export const createProjectInterestedSuccess: ActionCreator<CreateProjectInterestedSuccess> = () => (
  {
    type: Types.CREATE_PROJECT_INTERESTED_SUCCESS
  }
);

export const createProjectInterestedFailure: ActionCreator<CreateProjectInterestedFailure> = () => (
  {
    type: Types.CREATE_PROJECT_INTERESTED_FAILURE
  }
);

export const createProjectInterested: ActionCreator<CreateProjectInterestedThunk> =
  (id: string, person: Person): CreateProjectInterestedThunk => {
    return (dispatch: Dispatch<RootState>): Promise<CreateProjectInterestedAction> => {
      dispatch(createProjectInterestedAttempt());

      return ApiClient.projectInterested.create(person, {projectId: id})
        .then((): CreateProjectInterestedSuccess => {
          return dispatch(createProjectInterestedSuccess());
        }).catch((): CreateProjectInterestedFailure => {
          return dispatch(createProjectInterestedFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/interested/create/CreateProjectInterested.actions.tsx